'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ContextComponent = require('../../../global/components/ContextComponent');
const cartActions = require('../../../global/actions/cartActions');
const CartStore = require('../../../global/stores/CartStore');

const PurchaseTracking = require('../../../global/mixins/purchaseTracking');
const { getCheckoutUrl, redirect } = require('../../../checkout/helpers/checkout-redirects');
const classNames = require('classnames');
const copy = require('../../../../../json/copy/itemActionButtons.json');

class PurchaseCartButton extends ContextComponent {
    constructor(props) {
        super(props);
        this._onClick = this._onClick.bind(this);
    }

    /**
     * if a tracking object is provided in props then this will fire the 'purchase click'
     * event and the addToCart E-commerce event
     *
     * @param {object} tracking
     * @param {string} tracking.url
     * @param {string} tracking.pageContext
     * @returns {PurchaseCartButton}
     * @private
     */
    _onClickTracking() {
        const { item, tracking, enableRequestNetPrice } = this.props;
        const { url, pageContext } = tracking || {};
        let purchaseTracking;
        let action;

        if (tracking) {
            // initialize purchaseTracking object
            purchaseTracking = new PurchaseTracking({ item });

            // get action for firing 'purchase click' event
            if (pageContext && pageContext.indexOf('message center') > -1) {
                action = `purchase button - ${pageContext} - link in conversation`;
            } else {
                action = `${pageContext} purchase button`;
            }

            // fire tracking events
            purchaseTracking.trackPurchaseEvent({ action });
            purchaseTracking.ecommerceAddToCartTracking({ url, isTrade: enableRequestNetPrice });
        }

        return this;
    }

    _onClick(e) {
        const { href } = e.target;
        const { item, addToCart } = this.props;
        const cartStore = this.context.getStore(CartStore);

        // fires tracking (if this.props.tracking is set)
        this._onClickTracking();

        // only add the item to the cart if addToCart is set to true and
        // the item is not already in the cart
        if (addToCart && !cartStore.isItemInCart(item)) {
            cartStore.getItemsCollection().once('cart:itemAdded', () => redirect(href));
            this.context.executeAction(cartActions.addToCart, { item });

            // want to wait for redirect to be called manually
            // after item has been added to the cart
            e.preventDefault();
        }
    }

    render() {
        const { item } = this.props;
        const buttonClass = this.props.buttonClass || 'button-large';
        const cls = classNames('button', 'button-primary', buttonClass);

        return (
            <a
                className={cls}
                href={getCheckoutUrl(item)}
                data-tn="item-actions-purchase-item"
                onClick={this._onClick}
            >
                {copy.purchase}
            </a>
        );
    }
}

// TODO: models such as item and transaction should not be passed directly
// only the props that are needed should be passed. Requires other changes.
PurchaseCartButton.propTypes = {
    item: PropTypes.object.isRequired,
    addToCart: PropTypes.bool,
    buttonClass: PropTypes.string,
    tracking: PropTypes.shape({
        pageContext: PropTypes.string,
        url: PropTypes.string,
    }),
};

module.exports = PurchaseCartButton;



// WEBPACK FOOTER //
// ./assets/js/components/ItemActionButtons/PurchaseCartButton/PurchaseCartButton.jsx